module.exports = __webpack_public_path__ + "static/media/quran.3dbc1171.svg";